import { Grid, Typography } from "@material-ui/core";
import SimpleTable from "../CustomTable/SimpleTable";
import CustomPagination from "../CustomPagination/CustomPagination";
import { renderTimeJalali } from "../../utils/TimeUtils";

const DeviceHistory = ({ records, changePage, page }) => {
  const styles = {
    header: { textAlign: "start", padding: "5px 15px", marginTop: "10px" },
    container: { padding: "5px 15px", margin: "0 auto" },
    pagination: {
      padding: "5px 15px",
      marginBottom: "10px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
  };
  let totalRecords = records[0].all_consumptions;
  const tableData = [];
  const totalPage =
    totalRecords % 20 !== 0
      ? Math.floor(totalRecords / 20) + 1
      : totalRecords / 20;
  const tableHeaders = [
    { title: "پروژه", key: "projectName" },
    { title: "دسته بندی", key: "deviceTag" },
    { title: "نوع دستگاه", key: "deviceType" },
    { title: "ارسال آخرین داده", key: "dataTime" },
    { title: "مقدار", key: "deviceValue" },
  ];
  records.forEach((record) => {
    tableData.push({
      projectName: record?.project_info?.water_meter_project_name,
      deviceTag: record?.tag_info?.water_meter_tag_name,
      deviceType: record?.type_info?.water_meter_type_name,
      dataTime: renderTimeJalali(record?.create_time),
      deviceValue: record?.value,
    });
  });
  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.header}>
        <Typography variant="h6" component="h6">
          سوابق داده ({totalRecords}
          {""}رکورد)
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.container}>
        <SimpleTable
          hasIndex={true}
          hasLink={false}
          darkHeader={true}
          data={tableData}
          header={tableHeaders}
          page={page}
          count={20}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={styles.pagination}>
        <CustomPagination
          page={page}
          totalPages={totalPage}
          pageSize={20}
          totalData={totalRecords}
          changePageFunc={changePage}
        />
      </Grid>
    </>
  );
};
export default DeviceHistory;
